const hrefMatches = {
	"\\bca\\b": "en-ca",
	"\\bau\\b": "en-au",
	"localhost([^.]|$)": "en-us",
	"\\bus\\b": "en-us",
	"\\.com(/|$)": "en-us",
};

export const getLocaleId = (href = window.location.href) => {
	const match = href.match(/\/([a-z]{2}-[a-z]{2})(\/|$)/);
	if (match) {
		return match[1];
	}

	for (const key in hrefMatches) {
		const regex = `${key}`;
		if (new RegExp(regex).test(href)) {
			return hrefMatches[key];
		}
	}
	return "en-us";
};

const isSite = (locale) => {
	return getLocaleId(window.location.href) === locale;
};

export const IS_AU_SITE = isSite("en-au");
export const IS_USA_SITE = isSite("en-us");
export const IS_CA_SITE = isSite("en-ca");

export const FLIGHT_SEARCH_MIN_DAYS_FROM_TODAY = 14;
export const TRAVEL_INSURANCE_LINK_US =
	"https://www.agentmaxonline.com/agentmaxweb/storefront/index.html#/home/?emaillinkcode=ABIYU4TLWGBGTNHC6ZWLRSKAR7AIBWE33AAW7OYIPBPWYZZAHMNFAPHPMCRSOIHOT2A76BONGXKQL73NZ75RJQPPH5HHTT7WBY42JRA%3d";
export const MUI_LICENSE_KEY =
	"922af3b2e61bd63dbac6098f405590c3Tz02MTM0NyxFPTE3MDk3MDQ4MTcxNDUsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";
export const FLIGHT_BEST_SORT = "BEST";
export const FLIGHT_CHEAPEST_SORT = "PRICE_LOW_TO_HIGH";
export const FLIGHT_DEPOSIT_SORT = "DEPOSIT_LOW_TO_HIGH";
export const FLIGHT_WEEKLY_SORT = "WEEKLY_LOW_TO_HIGH";
export const DEFAULT_FLIGHT_SORT = FLIGHT_BEST_SORT;
export const SHOW_CABIN_CLASS = true;
export const FEATURE_FLAG_MOBILE_NEW_DATEPICKER = false;
export const NUMBER_OF_SECONDS_IN_WEEK = 604800;
export const BOOKING_PER_PAGE = 5;
export const MINIMUM_PURCHASE_PRICE = 200; // $2: Must agree with plt-backend constant of the same name
